import { render } from "./IconSet.vue?vue&type=template&id=46eae2fc"
import script from "./IconSet.vue?vue&type=script&lang=js"
export * from "./IconSet.vue?vue&type=script&lang=js"

import "./IconSet.vue?vue&type=style&index=0&id=46eae2fc&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__